import React, {useContext} from 'react';
import ProductCategories from "../ProductCategories";
import ProductSectors from "../ProductSectors";
import ProductBrands from "../ProductBrands";
import FiltersToggle from "./FiltersToggle";
import HireOrSaleOptions from "./HireOrSaleOptions";
import Button from "../Elements/Button";
import {ButtonStyles,allProductsUrl} from "../Elements/consts"
import {setViewProductsPageInfo, toggleFilters} from "../Functions/Helpers"
import {ICON_REFRESH, FONTELLO_ENTYPO_CANCEL_CIRCLED} from "../SVG/consts"
import {WooContext} from "../WooContext";
import SvgLink from "../SVG";

function Filters() {
    const {productCategories, currentCategoryState, productSectors, productBrands, currentSectorState, currentBrandState, pageInfoState} = useContext(WooContext);
    const [,setCurrentCategory] = currentCategoryState;
    const [,setCurrentBrand] = currentBrandState;
    const [,setPageInfo] = pageInfoState;
    const [,setCurrentSector] = currentSectorState;
    return (
        <div className="woo-sidebar-inner filters">
            <h3 className="sidebar-heading">
                <span>Filters</span>
                <Button href={allProductsUrl} style={ButtonStyles.icon} onClick={(e) => {
                    e.preventDefault();
                    setViewProductsPageInfo();
                    setCurrentCategory({databaseId:0});
                    setCurrentSector({databaseId:0});
                    setCurrentBrand({databaseId:0});
                    setPageInfo({databaseId:0})
                }}><SvgLink {...ICON_REFRESH}/></Button>
                <Button className="button-close" style={ButtonStyles.icon} onClick={(e) => {
                    e.preventDefault();
                    toggleFilters();
                    window.scrollTo(0, 0);
                }}>
                    <SvgLink {...FONTELLO_ENTYPO_CANCEL_CIRCLED}/>
                </Button>
            </h3>
            <FiltersToggle heading="Category">
                <ProductCategories {...productCategories} />
            </FiltersToggle>
            <FiltersToggle heading="Hire & Buy">
                <HireOrSaleOptions/>
            </FiltersToggle>
            <FiltersToggle heading="Sectors">
                <ProductSectors {...productSectors} />
            </FiltersToggle>
            <FiltersToggle heading="Brand">
                <ProductBrands {...productBrands} />
            </FiltersToggle>
        </div>
    )
}

export default Filters;